import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ConfigurationService } from '../services/configuration.service';
import { CacheService } from '../services/cache.service';
import { CommonService } from '../services/common.service';
import { CacheKey } from '../constants/cachekey.constants';
import { UserTitleType } from '../enums/user-title-type.enum';
import { Router } from '@angular/router';
import flatten from 'lodash-es/flatten';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { JoinNavigation } from '../enums/join-navigation.enum';
import { ProductService } from '../../common/services/product.service';
import { AppMessageService } from '../../app-message.service';
import { MemberLevel } from '../enums/member-level.enum';
import { ActiveSessionService } from '../services/active-session.service';
import { TranslateParam, DynamicRoute } from '../../common/interfaces/index';
import { MenuItem } from '../interfaces/menu-item.interface';
import { MenuPortal } from '../enums/menu-portal.enum';
import { MemberType } from '../enums/member-type.enum';
import { DynamicPageSlugNames } from '../constants/dynamic-page-slug.constant';
import { Subscription } from 'rxjs/Subscription';
import { PortalCountry } from '../interfaces/portal-country.interface';
import { Country } from '../interfaces/country.interface';
import { ReportOnlyCountryService } from '../services/report-only-country.service';
import { Portals } from 'src/app/common/enums/portal.enum';

@Component({
  selector: 'app-join-mega-menu',
  templateUrl: '../templates/template1/views/join-mega-menu.component.html',
  styleUrls: [
    '../templates/template1/themes/default/less/join-mega-menu.component.less'
  ], animations: [
    trigger('slideInOut', [
      state('in', style({
        overflow: 'hidden',
        height: '*',
        opacity: '1'
      })),
      state('out', style({
        opacity: '0',
        overflow: 'hidden',
        height: '0px'
      })),
      transition('in <=> out', animate('400ms ease-in-out'))
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JoinMegaMenuComponent implements OnInit {
  @Input() menuCollapsed = false;
  @Output("escapeClicked") public escapeClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  store: any;
  storeId: number;
  languageCode: string;
  countryCode: string;
  memberTitle = MemberLevel;
  memberTitleId: number = MemberLevel.RETAIL;
  selected = -1;
  s3BucketUrl = environment.cdnURL;
  cookieService: CookieService = new CookieService(document);
  cardsContent: any[];
  siteMapId: number;
  joinNavPath = JoinNavigation;
  translateParams: TranslateParam;
  appSites: MenuItem[];
  loadSiteMaps = false;
  siteMapsSubscription: Subscription;
  @Output() public joinMenuCollapsed: EventEmitter<boolean> = new EventEmitter<boolean>();

  isFocused = false;
  constructor(
    private _configurationService: ConfigurationService,
    private _cacheService: CacheService,
    private _commonService: CommonService,
    private _activeSessionService: ActiveSessionService,
    private _router: Router,
    private _appMessageService: AppMessageService,
    private _reportOnlyCountryService: ReportOnlyCountryService
  ) { }
  ngOnInit(): void {
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    this.countryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.memberTitleId = this._activeSessionService.getMemberTitleId();    // All Categories
    this.store = this._cacheService.get(CacheKey.StoreConfiguration);
    this.getMenus();
    this.getSiteMapsSubject();
  }


  /**
 * @description
 * @date 2019-09-11
 * @private
 * @memberof MegaMenuComponent
 */
  private getSiteMapsSubject(): void {
    this.siteMapsSubscription = this._appMessageService.getSiteMapsSubject().subscribe(x => {
      if (this.loadSiteMaps) {
        this.loadSiteMaps = false;
        this.getMenus();
      }
    });
  }

  /**
   * @description This method used to get sitemap id for join header
   * getContent
   * @memberof JoinMegaMenuComponent
   */
  getMenus(): void {
    const menus = this._cacheService.get(CacheKey.SiteMaps);
    // join header dynamic page
    if (menus && menus.length) {
      const joinHeader: MenuItem = menus.find(x => x.slug === DynamicPageSlugNames.JOIN_HEADER);
      if (joinHeader) {
        const siteMapId = joinHeader.siteMapId;
        if (siteMapId) {
          this.getCardsContent(siteMapId);
        }
      }
    } else {
      this.loadSiteMaps = true;
    }
  }

  /**
   * @description
   * @date 2018-09-17
   * @param {number} sitemapId
   * @memberof JoinMegaMenuComponent
   */
  getCardsContent(sitemapId: number) {
    this._commonService.getCardsContentBySitemapId(sitemapId).subscribe(response => {
      if (response) {
        this.cardsContent = response;
        const cards: any = document.querySelectorAll('.join-menu-block div[data-t-card]');
        if (cards) {
          for (const card in cards) {
            if (Number(card) >= 0) {
              const temp = cards[card].getAttribute('data-t-card');
              if (this.cardsContent) {
                // tslint:disable-next-line:forin
                for (const place in this.cardsContent) {
                  const placeholder = this.cardsContent[place];
                  if (placeholder.indexId === temp) {
                    if (placeholder.cardContent !== '') {
                      cards[card].innerHTML = placeholder.cardContent;
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
      error => {
        this.translateParams = this._commonService.handleError(error);
      });
  }

  /**
   * @description
   * @date 2018-09-17
   */
  navigateToJoinSite(route: string): void {
    const portalCountries: PortalCountry[] = this._cacheService.get(CacheKey.PortalCountries);
    if (portalCountries && portalCountries.length > 0) {
      const countries: Country[] = flatten(portalCountries.map(portal => portal.countries));
      if (countries && countries.length > 0) {
        const country = countries.find(x => x.isocodeThree.toLowerCase() === this.countryCode.toLowerCase());
        if ((country && !country.titanPlatformEnabled) || (country && !this._reportOnlyCountryService.hasAccess(Portals.Join))) {
          this._commonService.scrollByValue(0, 0, 0);
          this._router.navigate(['./' + this.countryCode.toLowerCase()
            + '/' + this.languageCode.toLowerCase() + '/' + route]);
          this.joinMenuCollapsed.emit(false);
          return;
        }
      }
    }
    if (environment.betaPortal) {
      const skipNavigation = this._commonService.checkSkipNavigation(this.countryCode.toLowerCase());
      if (skipNavigation) {
        this._commonService.scrollByValue(0, 0, 0);
        this._router.navigate(['./' + this.countryCode.toLowerCase()
          + '/' + this.languageCode.toLowerCase() + '/' + route]);
        return;
      }

    }
    let redirectUrl = environment.enrollSiteURL + '/' + this.countryCode.toLowerCase() +
      '/' + this.languageCode.toLowerCase() + '/' + route;
    redirectUrl = this._commonService.appendFBOID(redirectUrl);
    window.location.href = redirectUrl;
  }

  /**
    * @description
    * @date 2018-10-03
    * @param {string} route
    * @memberof ProductComponent
    */
  navigateToPortal(dynamicRoute: DynamicRoute): void {
    let route = dynamicRoute.route;
    if (route) {
      if (environment.betaPortal) {
        const skipNavigation = this._commonService.checkSkipNavigation(this.countryCode.toLowerCase());
        if (skipNavigation) {
          if (this._commonService.navigateToInternalPreview(route)) {
            const url = route.split('/');
            this.navigateToPreviewPage(url);
            return;
          }
        } else {
          route = this._commonService.constructBetaUrl(route);
        }
      }
      if (route && (route.indexOf('?store') > -1 || route.indexOf('&store') > -1)) {
        route = route + '&langID=' + (this.languageCode ? this.languageCode.split('-')[0] : 'en');
      }
      window.open(route, dynamicRoute.target);
    }
  }
  /**
   * @description goto Joinby trigger the joinnow button
   * @author njagadeesan
   * @date 2020-04-13
   * @param {JoinNavigation} route
   * @memberof JoinMegaMenuComponent
   */
  gotoJoin(route: JoinNavigation): void {
    const joinHereBtn: any = document.querySelector('#join-now-card-js .banner-button a')
    if (joinHereBtn) {
      joinHereBtn.click();
    } else {
      this.navigateToJoinSite(route);
    }
  }

  /**
   * @description
   * @date 2019-07-24
   * @param {string[]} url
   * @memberof JoinMegaMenuComponent
   */
  navigateToPreviewPage(url: string[]): void {
    let slug: string;
    if (url && url.length) {
      slug = url[url.length - 1];
      slug = slug.indexOf('?') > -1 ? slug.split('?')[0] : slug;
      this._router.navigate(['./' + this.countryCode.toLowerCase()
        + '/' + this.languageCode.toLowerCase() + '/' + slug]);
    }
  }

  /**
   * @description
   * @date 2018-09-17
   * @param {boolean} isCollapse
   * @param {*} event
   * @memberof JoinMegaMenuComponent
   */
  setCollapse(isCollapse: boolean, event: any): void {
    if (event) {
      // event.stopPropagation();
    }
    this._appMessageService.setCollapseMenu(isCollapse);
  }

  ngOnDestroy(): void {
    if (this.siteMapsSubscription) {
      this.siteMapsSubscription.unsubscribe();
    }
  }
  toogleJoinMenuDisplayCSS(menuCollapsed: boolean) {
    const displayMode = menuCollapsed ? 'block' : 'none';
    if (menuCollapsed === true) {
      this.focusJoinTitleLink();
    } else {
      this.isFocused = false;
    }
    return {
      display: displayMode
    };
  }

  focusJoinTitleLink() {
    if (this.isFocused === false) {
      setTimeout(() => {
        const inputField: HTMLElement = document.querySelectorAll('.OpportunityTitle')[0] as HTMLElement;
        inputField && inputField.focus();
      }, 1000);
      this.isFocused = true;
    }
  }

  onEscape() {
    // console.log('Escape clicked');
    this.escapeClicked.emit(true);
  }
}
